import { render, staticRenderFns } from "./product_type.vue?vue&type=template&id=69917fba&scoped=true&"
import script from "./product_type.vue?vue&type=script&lang=js&"
export * from "./product_type.vue?vue&type=script&lang=js&"
import style0 from "./product_type.vue?vue&type=style&index=0&id=69917fba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69917fba",
  null
  
)

export default component.exports